/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose } from 'recompose'
import { connect } from 'react-redux'
import _get from 'lodash/get'
import { EMPTY_OBJECT } from 'constants/frozenObjects'
import { withLocalization } from 'hocs/localization'
import { getStates } from 'redux-app/selectors/apiData'
import { getUserDetails } from 'redux-app/selectors/user'
import { getPrintedDateLocal } from 'utils/date'
import { getCurrencySymbol, getPostalCodeFormatted } from 'utils/user'
import CurrentSubscription from './CurrentSubscription'
import { SUBSCRIPTION_PLAN_TYPE } from 'constants/subscription'
import {  getUserFutureSubscription, isEnrollAvailable } from 'redux-app/selectors/user'

export default compose(
  connect(
    (state, props) => {
      const { plan } = props
      const userDetails = getUserDetails(state) || { creditCard:{} }
      const currentSubscription = userDetails.subscription
      const futureSubscription = getUserFutureSubscription(state) || EMPTY_OBJECT
      const stateAbbr = _get(
        getStates(state).find(state => state.id === userDetails.shippingAddress.stateId),
        'isoCode',
        '',
      )
      const { address1, city, postalCode } = userDetails.shippingAddress
      return {
        currency: getCurrencySymbol(_get(plan, 'currency', EMPTY_OBJECT)),
        plan: plan || EMPTY_OBJECT,
        userDetails,
        nextBilling: ('nextBilling' in currentSubscription && currentSubscription.nextBilling) ?
          getPrintedDateLocal(currentSubscription.nextBilling) : null,
        lastBilling: ('lastBilling' in currentSubscription && currentSubscription.lastBilling) ?
          getPrintedDateLocal(currentSubscription.lastBilling) : null,
        address: `${address1}, ${city}, ${stateAbbr} ${getPostalCodeFormatted(postalCode)}`,
        businessName: _get(userDetails, ['company', 'name']),
        contractType: currentSubscription.subscriptionContractType === SUBSCRIPTION_PLAN_TYPE.contract ? 'Contract' : 'Mo-2-Mo',
        userSubscription: currentSubscription,
        futureSubscription,
        isEnrollAvailable: isEnrollAvailable(state)
      }
    },
    null,
  ),
  withLocalization('profile.currentSubscription'),
)(CurrentSubscription)
